import { render, staticRenderFns } from "./AwardVehicleField.vue?vue&type=template&id=49d3fa24"
import script from "./AwardVehicleField.vue?vue&type=script&lang=js"
export * from "./AwardVehicleField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports